import { render, staticRenderFns } from "./ParticipationRelationType.vue?vue&type=template&id=404a7107"
import script from "./ParticipationRelationType.vue?vue&type=script&lang=js"
export * from "./ParticipationRelationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports